import React, { useState, useEffect } from "react";
import axios from "axios";
import "./styles/Mainstyle.css";
import "./styles/Items.css";
import jsonData from "./data/Items.json";
import { loadAllAudio } from "./components/audioLoader";
import { audioFiles } from "./components/audioFiles";
import { Howler } from "howler";



import NussweisSequence1 from "./assets/Tutorin/Tutorium1_1.gif";
import NussweisSequence2 from "./assets/Tutorin/Tutorium1_2.gif";
import NussweisSequence3 from "./assets/Tutorin/Tutorium1_3.gif";
import NussweisSequence4 from "./assets/Tutorin/Tutorium1_4.gif";
import NussweisSequence5 from "./assets/Tutorin/Tutorium1_5.gif";
import NussweisSequence6 from "./assets/Tutorin/Tutorium1_6.gif";
import NussweisSequence7 from "./assets/Tutorin/Tutorium1_7.gif";
import NussweisSequence8 from "./assets/Tutorin/Tutorium1_8.gif";
import NussweisSequence9 from "./assets/Tutorin/Tutorium1_9.gif";
import NussweisSequence10 from "./assets/Tutorin/Tutorium1_10.gif";
import NussweisSequence11 from "./assets/Tutorin/Tutorium1_11.gif";
import NussweisSequence12 from "./assets/Tutorin/Tutorium1_12.gif";
import NussweisSequence13 from "./assets/Tutorin/Tutorium1_13.gif";
import NussweisSequence14 from "./assets/Tutorin/Tutorium1_14.gif";
import NussweisSequence15 from "./assets/Tutorin/Tutorium1_15.gif";
import NussweisIdle from "./assets/Tutorin/Nussweis_idle.gif";
import NussweisIdle2 from "./assets/Tutorin/Nussweis_idle2.gif";
import Ende_Teil1 from "./assets/Tutorin/Ende_Teil1.gif";
import Ende_Teil2 from "./assets/Tutorin/Ende_Teil2.gif";

Howler.autoUnlock = true;
Howler.autoSuspend = false;

function Rechtschreiben()
{
    
    const version = "1.1.2";
    const queryParams = new URLSearchParams(window.location.search)
    const[Api, setApi] = useState("https://api.kompass-lesen.de/v1000/");
    const [sounds, setSounds] = useState(null);
    const [audioReady, setAudioReady] = useState(false);
    const containerRef = React.useRef(null);
    const [scale, setScale] = useState(1);
    const [showDiagnosticOverlay, setShowDiagnostikOverlay] = useState(false)
    const [geschriebenesWort, setGeschriebenesWort] = useState("");
    const [Majuskeln, setMajuskeln] = useState(false);
    const [MagicLoading, setMagicLoading] = useState(false);
    const [OkayButton, setOkayButton] = useState(false);
    const [usedItems, setUsedItems] = useState([]);
    const [Korrekturen, setKorrekturen] = useState(0);
    const [KeyLog, setKeyLog] = useState([]);
    const [StimulusTime, setStimulusTime] = useState(Date.now());
    const [WritingStarted, setWritingStarted] = useState(false);
    const [StartDelay, setStartDelay] = useState(0);
    const [WritingStartTime, setWritingStartTime] = useState(0);
    const [WritingTime, setWritingTime] = useState(0);
    const [FinishTime, setFinishTime] = useState(0);
    const [FinalDelay, setFinalDelay] = useState(0);
    const [Intro, setIntro] = useState(true);
    const [Inside, setInside] = useState(false);
    const [Glow, setGlow] = useState(false);
    const [LogInMask, setLogInMask] = useState(true);
    const Schulcode = queryParams.get('SchulCode');
    const LehrerCode = queryParams.get('userCode');
    const SchulerCode = queryParams.get('schulerCode');
    const SchulerKlasse = queryParams.get('Klassenname');
    const SchulerKlassenstufe = parseInt(queryParams.get('Klassenstufe'));
    const [UseKlassenstufe, setUseKlassenstufe] = useState(SchulerKlassenstufe);
    const [testTicket, setTestTicket] = useState();
    const [HohlenEingang, setHohlenEingang] = useState(false);
    const [FadeOut, setFadeout] = useState(false);
    const [showSchild, setShowSchild] = useState(true);
    const [Knackomat_pressed, setKnackomat_pressed] = useState(false);
    const [ShowItem, setShowItem] = useState(false);
    const [ShowTutItem1, setShowTutItem1] = useState(false);
    const [ShowTutItem2, setShowTutItem2] = useState(false);
    const [KeyGroßschreiben, setKeyGroßschreiben] = useState('Key3');
    const [KeyBackspace, setKeyBackspace] = useState('Key2');
    const [KeyE, setKeyE] = useState('Key1');
    const [KeyN, setKeyN] = useState('Key1');
    const [KeyT, setKeyT] = useState('Key1');
    const [KeyF, setKeyF] = useState('Key1');
    const [KeyU, setKeyU] = useState('Key1');
    const [Keyß, setKeyß] = useState('Key1');
    const [inTutorial, setInTutorial] = useState(true);
    const [diagnosisActive, setDiagnosisActive] = useState(false);
    const inTutorialRef = React.useRef(true);
    const [TutorialCount, setTutorialCount] = useState([]);
    const [KeyboardAktiv, setKeyboardAktiv] = useState(false);
    const [NussButton, setNussButton] = useState('NussButton');
    const [AudioRepeatButton, setAudioRepeatButton] = useState('AudioRepeatButton');
    const [HohleClicked, setHohleClicked] = useState(false);
    const [Items, setItems] = useState();
    const [Tutor, setTutor] = useState("Nussweis_gone");
    const [imagesReady, setImagesReady] = useState(false);
    const [HohleEnabled, setHohleEnabled] = useState(true);
    const [WortzumLob, setWortzumLob] = useState([]);
    const [ReplayEnabled, setReplayEnabled] = useState(false);
    const [idle2Enabled, setIdle2Enabled] = useState(false);
    const [UmfangItems, setUmfangItems] = useState(0);
    const [showVersion, setShowVersion] = useState(true);
    const [loadingProgress, setLoadingProgress] = useState(0);
    const [loadedAssetCount, setLoadedAssetCount] = useState(0);
    const [totalAssetCount, setTotalAssetCount] = useState(0);
    const [loadingLabel, setLoadingLabel] = useState("Diagnostik wird vorbereitet …");
    const [loadingError, setLoadingError] = useState(null);
    const [appReady, setAppReady] = useState(false);
    const [audioUnlockFailed, setAudioUnlockFailed] = useState(false);
    const [replaysRemaining, setReplaysRemaining] = useState(0);
    const [replayBusy, setReplayBusy] = useState(false);
    const [soundTestStarted, setSoundTestStarted] = useState(false);
    const [soundTestPassed, setSoundTestPassed] = useState(false);
    const [soundTestPlaying, setSoundTestPlaying] = useState(false);
    const [soundTestError, setSoundTestError] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [ManagedReferenzItems, setManagedReferenzItems] = useState(0);
    const DemoModus = queryParams.get('Demo');

const preloadStartedRef = React.useRef(false);

    const ButtonSound1_Play   = () => sounds.ButtonSound1.play();
    const ButtonSound2_Play   = () => sounds.ButtonSound2.play();
    const Saving_Play = () => sounds.Saving.play();
    const MagicLoad_Play = () => sounds.MagicLoad.play();

    const itemSoundKeys = {
    "grüßen": "grußen",
    "Hände": "Hande",
    "Häuser": "Hauser",
    "Höhe": "Hohe",
    "Küche": "Kuche",
    "Mäuse": "Mause",
    "Möhre": "Mohre",
    "Mühle": "Muhle",
    "Mütze": "Mutze",
    "Soße": "Soße",
    "Straße": "Straße",
    "träumen": "traumen",
    "Wäsche": "Wasche",
    "Kälte": "Kalte"
};

    const sequence1BlobRef = React.useRef(null);
    const sequence1ObjectUrlRef = React.useRef(null);
    const sequence2BlobRef = React.useRef(null);
    const sequence2ObjectUrlRef = React.useRef(null);
    const sequence3BlobRef = React.useRef(null);
    const sequence3ObjectUrlRef = React.useRef(null);
    const sequence3AudioStartedRef = React.useRef(false);
    const sequence4BlobRef = React.useRef(null);
    const sequence4ObjectUrlRef = React.useRef(null);
    const sequence5BlobRef = React.useRef(null);
    const sequence5ObjectUrlRef = React.useRef(null);
    const sequence6BlobRef = React.useRef(null);
    const sequence6ObjectUrlRef = React.useRef(null);
    const sequence7BlobRef = React.useRef(null);
    const sequence7ObjectUrlRef = React.useRef(null);
    const sequence8BlobRef = React.useRef(null);
    const sequence8ObjectUrlRef = React.useRef(null);
    const sequence9BlobRef = React.useRef(null);
    const sequence9ObjectUrlRef = React.useRef(null);
    const sequence10BlobRef = React.useRef(null);
    const sequence10ObjectUrlRef = React.useRef(null);
    const sequence11BlobRef = React.useRef(null);
    const sequence11ObjectUrlRef = React.useRef(null);
    const sequence12BlobRef = React.useRef(null);
    const sequence12ObjectUrlRef = React.useRef(null);
    const sequence13BlobRef = React.useRef(null);
    const sequence13ObjectUrlRef = React.useRef(null);
    const sequence14BlobRef = React.useRef(null);
    const sequence14ObjectUrlRef = React.useRef(null);
    const sequence15BlobRef = React.useRef(null);
    const sequence15ObjectUrlRef = React.useRef(null);
    const sequenceEnde1BlobRef = React.useRef(null);
    const sequenceEnde1ObjectUrlRef = React.useRef(null);
    const sequenceEnde2BlobRef = React.useRef(null);
    const sequenceEnde2ObjectUrlRef = React.useRef(null);
    const sequence4AudioStartedRef = React.useRef(false);
    const sequence5AudioStartedRef = React.useRef(false);
    const sequence6AudioStartedRef = React.useRef(false);
    const sequence7AudioStartedRef = React.useRef(false);
    const sequence8AudioStartedRef = React.useRef(false);
    const sequence9AudioStartedRef = React.useRef(false);
    const sequence10AudioStartedRef = React.useRef(false);
    const sequence11AudioStartedRef = React.useRef(false);
    const sequence12AudioStartedRef = React.useRef(false);
    const sequence13AudioStartedRef = React.useRef(false);
    const sequence14AudioStartedRef = React.useRef(false);
    const sequence15AudioStartedRef = React.useRef(false);
    const sequenceEnde1AudioStartedRef = React.useRef(false);
    const sequenceEnde2AudioStartedRef = React.useRef(false);

    const [sequence1Src, setSequence1Src] = useState(null);
    const [sequence2Src, setSequence2Src] = useState(null);
    const [sequence3Src, setSequence3Src] = useState(null);
    const [sequence4Src, setSequence4Src] = useState(null);
    const [sequence5Src, setSequence5Src] = useState(null);
    const [sequence6Src, setSequence6Src] = useState(null);
    const [sequence7Src, setSequence7Src] = useState(null);
    const [sequence8Src, setSequence8Src] = useState(null);
    const [sequence9Src, setSequence9Src] = useState(null);
    const [sequence10Src, setSequence10Src] = useState(null);
    const [sequence11Src, setSequence11Src] = useState(null);
    const [sequence12Src, setSequence12Src] = useState(null);
    const [sequence13Src, setSequence13Src] = useState(null);
    const [sequence14Src, setSequence14Src] = useState(null);
    const [sequence15Src, setSequence15Src] = useState(null);
    const [sequenceEnde1Src, setSequenceEnde1Src] = useState(null);
    const [sequenceEnde2Src, setSequenceEnde2Src] = useState(null);
    const [sequence1Running, setSequence1Running] = useState(false);
    const [sequence2Running, setSequence2Running] = useState(false);
    const [sequence3Running, setSequence3Running] = useState(false);
    const [sequence4Running, setSequence4Running] = useState(false);
    const [sequence5Running, setSequence5Running] = useState(false);
    const [sequence6Running, setSequence6Running] = useState(false);
    const [sequence7Running, setSequence7Running] = useState(false);
    const [sequence8Running, setSequence8Running] = useState(false);
    const [sequence9Running, setSequence9Running] = useState(false);
    const [sequence10Running, setSequence10Running] = useState(false);
    const [sequence11Running, setSequence11Running] = useState(false);
    const [sequence12Running, setSequence12Running] = useState(false);
    const [sequence13Running, setSequence13Running] = useState(false);
    const [sequence14Running, setSequence14Running] = useState(false);
    const [sequence15Running, setSequence15Running] = useState(false);
    const [sequenceEnde1Running, setSequenceEnde1Running] = useState(false);
    const [sequenceEnde2Running, setSequenceEnde2Running] = useState(false);


    const preloadedImagesRef = React.useRef([]);

    const Play_Item_Sound = async (wort) => {
    const soundKey = itemSoundKeys[wort] || wort;
    const itemSound = sounds?.[soundKey];

    console.log("Item-Audio wird angefordert:", {
        wort,
        soundKey,
        audioContext: Howler.ctx?.state,
        howlState: itemSound?.state()
    });

    if (!itemSound) {
        console.error(
            `Für das Item "${wort}" wurde kein Sound gefunden. ` +
            `Gesuchter Key: "${soundKey}"`
        );

        return false;
    }

    try {
        Howler.mute(false); Howler.volume(1);
        /*
         * iPadOS kann den AudioContext zwischendurch auf
         * "suspended" oder "interrupted" setzen.
         */
        if (Howler.ctx && Howler.ctx.state !== "running") 
        {
            console.warn(`AudioContext vor "${wort}":`,Howler.ctx.state);
            await Howler.ctx.resume();
        }

        if (Howler.ctx && Howler.ctx.state !== "running") {
            console.error(`AudioContext für "${wort}" bleibt gesperrt:`, Howler.ctx.state);
            return false;
        }

        // Verhindert Überlagerungen bzw. alte Wiedergaben
        itemSound.stop();

        return await new Promise((resolve) => {
            let finished = false;

            const soundId = itemSound.play();

            const finish = (result) => {
                if (finished) return;

                finished = true;
                resolve(result);
            };

            itemSound.once("play", () => {console.log(`Item-Audio "${wort}" läuft.`,
                        {
                            soundId,
                            audioContext: Howler.ctx?.state
                        }
                    );

                    finish(true);
                },
                soundId
            );

            itemSound.once("playerror", (id, error) => {
                    console.error(`Wiedergabefehler bei "${wort}":`,
                        error,
                        {
                            soundId: id,
                            audioContext: Howler.ctx?.state,
                            howlState: itemSound.state()
                        }
                    );

                    finish(false);
                },
                soundId
            );

            itemSound.once(
                "loaderror",
                (id, error) => {
                    console.error(
                        `Ladefehler bei "${wort}":`,
                        error,
                        {
                            soundId: id,
                            howlState: itemSound.state()
                        }
                    );

                    finish(false);
                },
                soundId
            );

            /*
             * Sicherheitsprüfung: Auf manchen iPads kommt weder
             * "play" noch "playerror".
             */
            setTimeout(() => {
                if (finished) return;

                const isPlaying = itemSound.playing(soundId);

                if (isPlaying) {
                    console.log(
                        `Item-Audio "${wort}" läuft laut Sicherheitsprüfung.`
                    );

                    finish(true);
                } else {
                    console.error(
                        `Item-Audio "${wort}" wurde nicht gestartet.`,
                        {
                            soundId,
                            audioContext: Howler.ctx?.state,
                            howlState: itemSound.state()
                        }
                    );

                    finish(false);
                }
            }, 1000);
        });
    } catch (error) {
        console.error(`Unerwarteter Audiofehler bei "${wort}":`,
            error
        );

        return false;
    }
};

    useEffect(()=>{
        if(DemoModus)
        {
            setUseKlassenstufe(0);
        }
    })

    useEffect(() => {
        inTutorialRef.current = inTutorial;
    }, [inTutorial]);

    useEffect(() => {
    console.log("audioReady:", audioReady);
    }, [audioReady]);

    useEffect(() => {
        console.log("imagesReady:", imagesReady);
    }, [imagesReady]);

useEffect(() => {
    if (preloadStartedRef.current) return;
    preloadStartedRef.current = true;

    let loadedCount = 0;

    const gifAssets = [
        {
            name: "Tutorial 1",
            src: NussweisSequence1,
            ref: sequence1BlobRef
        },
        {
            name: "Tutorial 2",
            src: NussweisSequence2,
            ref: sequence2BlobRef
        },
        {
            name: "Tutorial 3",
            src: NussweisSequence3,
            ref: sequence3BlobRef
        },
        {
            name: "Tutorial 4",
            src: NussweisSequence4,
            ref: sequence4BlobRef
        },
        {
            name: "Tutorial 5",
            src: NussweisSequence5,
            ref: sequence5BlobRef
        },
        {
            name: "Tutorial 6",
            src: NussweisSequence6,
            ref: sequence6BlobRef
        },
        {
            name: "Tutorial 7",
            src: NussweisSequence7,
            ref: sequence7BlobRef
        },
        {
            name: "Tutorial 8",
            src: NussweisSequence8,
            ref: sequence8BlobRef
        },
        {
            name: "Tutorial 9",
            src: NussweisSequence9,
            ref: sequence9BlobRef
        },
        {
            name: "Tutorial 10",
            src: NussweisSequence10,
            ref: sequence10BlobRef
        },
        {
            name: "Tutorial 11",
            src: NussweisSequence11,
            ref: sequence11BlobRef
        },
        {
            name: "Tutorial 12",
            src: NussweisSequence12,
            ref: sequence12BlobRef
        },
        {
            name: "Tutorial 13",
            src: NussweisSequence13,
            ref: sequence13BlobRef
        },
        {
            name: "Tutorial 14",
            src: NussweisSequence14,
            ref: sequence14BlobRef
        },
        {
            name: "Tutorial 15",
            src: NussweisSequence15,
            ref: sequence15BlobRef
        },
        {
            name: "Abschluss 1",
            src: Ende_Teil1,
            ref: sequenceEnde1BlobRef
        },
        {
            name: "Abschluss 2",
            src: Ende_Teil2,
            ref: sequenceEnde2BlobRef
        }
    ];

    const normalImages = [
        {
            name: "Eichhörnchen wartet",
            src: NussweisIdle
        },
        {
            name: "Eichhörnchen in der Höhle",
            src: NussweisIdle2
        }
    ];

    const audioCount = Object.keys(audioFiles).length;

    const total =
        audioCount +
        gifAssets.length +
        normalImages.length;

    setTotalAssetCount(total);

    const reportLoaded = (label) => {
        
        loadedCount += 1;

        const percentage = Math.round(
            (loadedCount / total) * 100
        );

        setLoadedAssetCount(loadedCount);
        setLoadingProgress(percentage);
        setLoadingLabel(label);
    };

    const preloadImage = (asset) => {
        return new Promise((resolve, reject) => {
            const image = new Image();

            image.onload = () => {
                preloadedImagesRef.current.push(image);

                reportLoaded(
                    `${asset.name} wurde geladen`
                );

                resolve();
            };

            image.onerror = () => {
                reject(
                    new Error(
                        `${asset.name} konnte nicht geladen werden`
                    )
                );
            };

            image.src = asset.src;
        });
    };

    const preloadGif = async (asset) => {
        const blob = await preloadGifAsBlob(
            asset.src
        );

        asset.ref.current = blob;

        reportLoaded(
            `${asset.name} wurde geladen`
        );
    };

    async function preloadAssets() {
        try {
            setLoadingLabel(
                "Audio- und Bilddateien werden geladen …"
            );

            const audioPromise = loadAllAudio(
                audioFiles,
                (audioName) => {
                    reportLoaded(
                    `Audio „${audioName}“ wurde geladen`
                 );
            },
            2
);

            const gifPromise = Promise.all(
                gifAssets.map(preloadGif)
            );

            const imagePromise = Promise.all(
                normalImages.map(preloadImage)
            );

            const [
                loadedSounds
            ] = await Promise.all([
                audioPromise,
                gifPromise,
                imagePromise
            ]);

            

            setSounds(loadedSounds);
            setAudioReady(true);
            setImagesReady(true);
            setLoadingProgress(100);
            setLoadingLabel("Alles bereit!");

            // Kurze Pause, damit 100 % sichtbar werden
            setTimeout(() => {
               
                    setAppReady(true);
                
            }, 400);
        } catch (error) {
           

            console.error(
                "Preload fehlgeschlagen:",
                error
            );

            setLoadingError(
                error.message ||
                "Die Dateien konnten nicht geladen werden."
            );
        }
    }

    preloadAssets();

}, []);


    const preloadGifAsBlob = async (src) => {
    const response = await fetch(src);

    if (!response.ok) {
        throw new Error(
            `GIF konnte nicht geladen werden: ${response.status} ${src}`
        );
    }

    const arrayBuffer = await response.arrayBuffer();

    return new Blob(
        [arrayBuffer],
        { type: "image/gif" }
    );
};
   
    const Lob1_Play = () => sounds.Lob1.play();

    const loadItems = () => {
    const zufaelligeAuswahl = (itemGruppe, anzahl = 3) => {
        return [...itemGruppe]
            .sort(() => Math.random() - 0.5)
            .slice(0, anzahl)
            .map(([ItemId, Bildimpuls, Wort, Varianten]) => ({
                ItemId,
                Bildimpuls,
                Wort,
                Varianten
            }));
    };

    const referenzItems1 = zufaelligeAuswahl(
        jsonData.ReferenzItems1
    );

    const referenzItems2 = zufaelligeAuswahl(
        jsonData.ReferenzItems2
    );

    const phonologischAuffaellige_anlautend = zufaelligeAuswahl(
        jsonData.Phonographisch_auffällige_anlautend_komplex
    );

    const phonologischAuffaellige_inlautend = zufaelligeAuswahl(
        jsonData.Phonographisch_auffällige_inlautend_komplex
    );

    const phonologischAuffaellige_auslautend= zufaelligeAuswahl(
        jsonData.Phonographisch_auffällige_auslautend_komplex
    );

    const schwa_e_zweisilber = zufaelligeAuswahl(
        jsonData.Schwa_E_in_Zweisilbern
    );

    const doppelkonsonanten_unmarkiert = zufaelligeAuswahl(
        jsonData.Doppelkonsonanten_unmarkiert
    );

    const doppelkonsonanten_markiert = zufaelligeAuswahl(
        jsonData.Doppelkonsonanten_markiert
    );

    const Dehnungsschreibung_Basis = zufaelligeAuswahl(
        jsonData.Dehnungsschreibungen_Basis
    );

    const Dehnungsschreibung_Aufbau = zufaelligeAuswahl(
        jsonData.Dehnungsschreibungen_Aufbau
    );

    const Silbeninitiales_h = zufaelligeAuswahl(
        jsonData.Silbeninitiales_h
    );

    const Auslaute = zufaelligeAuswahl(
        jsonData.Auslaute
    );

    const Umlaute = zufaelligeAuswahl(
        jsonData.Umlaute
    );

    const ver_und_vor_Schreibung = zufaelligeAuswahl(
        jsonData.ver_und_vor_Schreibung
    );

    const Silbisch_vererbte_Schreibung = zufaelligeAuswahl(
        jsonData.Silbisch_vererbte_Schreibung
    );


    if (UseKlassenstufe == 4 || UseKlassenstufe == 3) {
    setUmfangItems(45);
    const items = [
        ...referenzItems1,
        ...referenzItems2,
        ...phonologischAuffaellige_anlautend,
        ...phonologischAuffaellige_inlautend,
        ...phonologischAuffaellige_auslautend,
        ...schwa_e_zweisilber,
        ...doppelkonsonanten_unmarkiert,
        ...doppelkonsonanten_markiert,
        ...Dehnungsschreibung_Basis,
        ...Dehnungsschreibung_Aufbau,
        ...Silbeninitiales_h,
        ...Auslaute,
        ...Umlaute,
        ...ver_und_vor_Schreibung,
        ...Silbisch_vererbte_Schreibung
    ];

    return [
    ...items.slice(0, 6),
    ...mischen(items.slice(6))
];
}

if (UseKlassenstufe == 2) {
    setUmfangItems(30);
    const items = [
        ...referenzItems1,
        ...referenzItems2,
        ...phonologischAuffaellige_anlautend,
        ...phonologischAuffaellige_inlautend,
        ...phonologischAuffaellige_auslautend,
        ...schwa_e_zweisilber,
        ...doppelkonsonanten_unmarkiert,
        ...doppelkonsonanten_markiert,
        ...Dehnungsschreibung_Basis,
        ...Silbeninitiales_h
    ];

    return [
    ...items.slice(0, 6),
    ...mischen(items.slice(6))
];
}

if (UseKlassenstufe == 1) {
    setUmfangItems(18);
    const items = [
        ...referenzItems1,
        ...referenzItems2,
        ...phonologischAuffaellige_anlautend,
        ...phonologischAuffaellige_inlautend,
        ...phonologischAuffaellige_auslautend,
        ...schwa_e_zweisilber
    ];

    return [
    ...items.slice(0, 6),
    ...mischen(items.slice(6))
];
}

if (DemoModus) {
    setUmfangItems(18);
    const items = [
        ...referenzItems1,
        ...referenzItems2,
        ...phonologischAuffaellige_anlautend,
        ...phonologischAuffaellige_inlautend,
        ...phonologischAuffaellige_auslautend,
        ...schwa_e_zweisilber
    ];

    return [
    ...items.slice(0, 6),
    ...mischen(items.slice(6))
];
}



return [];


    };
    ///Fisher-Yates-Algorithmus////
    const mischen = (items) => {
    const gemischteItems = [...items];

    for (let i = gemischteItems.length - 1; i > 0; i--) {
        const zufallsIndex = Math.floor(Math.random() * (i + 1));

        [gemischteItems[i], gemischteItems[zufallsIndex]] =
            [gemischteItems[zufallsIndex], gemischteItems[i]];
    }

    return gemischteItems;
    };
///Fisher-Yates-Algorithmus////

    useEffect(() => {
    const loadedItems = loadItems();
    setItems(loadedItems);
}, []);

    

     const Großschreiben = () =>{
        if(KeyboardAktiv && !inTutorial)
        {
        LogStart();
        LogFinish();
        KeyLog.push("↥");
        if(Majuskeln){setMajuskeln(false); ButtonSound2_Play();}
        else
        {
            setMajuskeln(true);
        }
        }
        if(inTutorial)
        {
            ButtonSound2_Play();
            if(TutorialCount.length == 1)
            {
                setMajuskeln(true);
                Tutorial_Step2();
            }

            if(TutorialCount.length == 7)
            {
                setMajuskeln(true);
            }
            
        }
        
        
     }

     const handleTaste = (key) => {
        if(!inTutorial && KeyboardAktiv)
        {
            ButtonSound1_Play();
            LogStart();
            LogFinish();
            let wort = geschriebenesWort+key;
            KeyLog.push(key);
            setGeschriebenesWort(wort);
            setTimeout(()=>{setMajuskeln(false)},200)
        }
        if(inTutorial && KeyboardAktiv)
        {
            ButtonSound1_Play();
            //console.log("Tutorial Counter: "+TutorialCount.length)
            if(key == "E" || key == "e" )
            {
                if(TutorialCount.length == 2)
                {
                    setGeschriebenesWort("E");
                    setTimeout(()=>{setMajuskeln(false);},200) 
                    Tutorial_Step3();
                }

                if(TutorialCount.length == 5)
                {
                    setGeschriebenesWort("Ente");
                    setTimeout(()=>{setMajuskeln(false);},200) 
                    Tutorial_Step6();
                }
            }

            if(key == "N" || key == "n")
            {
                if(TutorialCount.length == 3)
                {
                    setGeschriebenesWort("En");
                    setTimeout(()=>{setMajuskeln(false);},200) 
                    Tutorial_Step4();
                }
            }

            if(key == "T" || key == "t")
            {
                if(TutorialCount.length == 4)
                {
                    setGeschriebenesWort("Ent");
                    setTimeout(()=>{setMajuskeln(false);},200) 
                    Tutorial_Step5();
                }
            }
            if(key == "F")
            {
                if(TutorialCount.length == 7)
                {
                    setGeschriebenesWort("F");
                    setTimeout(()=>{setMajuskeln(false);},200);
                    Tutorial_Step8(); 
                }
            }
            if(key == "u" || key == "U")
            {
                if(TutorialCount.length == 8)
                {
                   setGeschriebenesWort("Fu");
                    setTimeout(()=>{setMajuskeln(false);},200);
                    Tutorial_Step9();  
                }
            }
            if(key == "ß" )
            {
                if(TutorialCount.length == 9)
                {
                    setGeschriebenesWort(<span style={{ whiteSpace: "nowrap" }}>Fu<span style={{ color: "red" }}>%</span></span>);
                    setTimeout(()=>{setMajuskeln(false);},200);
                    Tutorial_Step10();  
                }

                if(TutorialCount.length == 11)
                {
                    setGeschriebenesWort("Fuß");
                    setTimeout(()=>{setMajuskeln(false);},200);
                    Tutorial_Step12();  
                }
            }
        }
     }

     const handleBackspace = () => {
        if(!inTutorial)
        {
            LogStart();
            LogFinish();
            let corrections = Korrekturen+1;
            KeyLog.push("←");
            setKorrekturen(corrections);
            setGeschriebenesWort(prev => prev.slice(0, -1));
        }
        if(inTutorial)
        {
            if(TutorialCount.length==10)
            {
                setGeschriebenesWort("Fu");
                setTimeout(()=>{setMajuskeln(false);},200);
                Tutorial_Step11(); 
            }
        }
       
     }

     const MagicLoadItem = (itemIndex = usedItems.length) => {
    setShowItem(false);
    setMagicLoading(true);
    setKeyF("Key1");
    setKeyE("Key1");
    setKeyN("Key1");
    setKeyU("Key1");
    setKeyß("Key1");
    setKeyT("Key1");

    if (!inTutorialRef.current) {
        MagicLoad_Play();
    }

    setTimeout(() => {
        setMagicLoading(false);

        if (!inTutorialRef.current) {
            const currentItem = Items?.[itemIndex];

            if (!currentItem) {
                console.error("Kein Item vorhanden.", {
                    itemIndex,
                    Items
                });
                return;
            }

            setTimeout(() => {
                setShowItem(true);

                console.log("Aktuelles Item:", currentItem.Wort);

                Play_Item_Sound(currentItem.Wort);

                setKeyboardAktiv(true);
                setStimulusTime(Date.now());
                setReplaysRemaining(2);
                setReplayBusy(false);
            }, 600);
        }
    }, 1500);
};

     const LogStart = () =>{
        if(!WritingStarted)
        {
            let StartTime = Date.now();
            setWritingStarted(true);
            let StartD = StartTime-StimulusTime;
            setStartDelay(StartD);
            setWritingStartTime(StartTime);
        }
     }

     const LogFinish = () =>{
        if(WritingStarted)
        {
            let FinTime = Date.now();
            let WritingTimeD = FinTime-WritingStartTime;
            setWritingTime(WritingTimeD);
            setFinishTime(FinTime);
        }
     }

         

     useEffect(() => {
        if(geschriebenesWort.length>1)
        {
            setOkayButton(true);
        }
        if(geschriebenesWort.length<2)
        {
            setOkayButton(false);
        }

     },[geschriebenesWort.length])

     useEffect(() => {
        const updateScale = () => {
            const viewportWidth =
                window.visualViewport?.width ?? window.innerWidth;

            const viewportHeight =
                window.visualViewport?.height ?? window.innerHeight;

            const designWidth = 1600;
            const designHeight = 900;

            const newScale = Math.min(
                viewportWidth / designWidth,
                viewportHeight / designHeight
            );

            setScale(newScale);
        };

        updateScale();

        window.addEventListener("resize", updateScale);
        window.visualViewport?.addEventListener("resize", updateScale);

        return () => {
            window.removeEventListener("resize", updateScale);
            window.visualViewport?.removeEventListener("resize", updateScale);
        };
    }, []);

    const handleOkayClick = () => {
        if(OkayButton && !inTutorial)
        {
            Saving_Play();
            setKnackomat_pressed(true);
            setOkayButton(false);
            const aktualisierteErgebnisse = SchreibungAuswerten();
            if (aktualisierteErgebnisse.length === 6 && aktualisierteErgebnisse.every(ergebnis => ergebnis.Rating !== 1 && ergebnis.Rating !== 2)
            ) {
            Finish_Diagnosis(aktualisierteErgebnisse);
            return;
            }
            setGeschriebenesWort("");
            WortzumLob.push(1);
            setTimeout(()=>{setKnackomat_pressed(false)},300)
            if(WortzumLob.length < UmfangItems)
            {
                if(WortzumLob.length == 5 || WortzumLob.length == 10 || WortzumLob.length == 15 || WortzumLob.length == 20 || WortzumLob.length == 25 || WortzumLob.length == 30 || WortzumLob.length == 35 || WortzumLob.length == 40)
                {
                    setShowItem(false);
                    const lobSounds = [
                    { sound: sounds.Lob1, delay: 4000 },
                    { sound: sounds.Lob2, delay: 4000 },
                    { sound: sounds.Lob3, delay: 4000 },
                    { sound: sounds.Lob4, delay: 4000 },
                    { sound: sounds.Lob5, delay: 4000 },
                    { sound: sounds.Lob6, delay: 8000 },
                    { sound: sounds.Lob7, delay: 4000 },
                    { sound: sounds.Lob8, delay: 4000 },
                    { sound: sounds.Lob9, delay: 7000 },
                    { sound: sounds.Lob10, delay: 4000 },
                ];

                const randomIndex = Math.floor(Math.random() * lobSounds.length);
                const ausgewaehltesLob = lobSounds[randomIndex];

                ausgewaehltesLob.sound.play();

                setTimeout(() => {MagicLoadItem(aktualisierteErgebnisse.length);}, ausgewaehltesLob.delay);
                }
                else
                {
                    MagicLoadItem(aktualisierteErgebnisse.length);;
                }
            }
            else
            {
                Finish_Diagnosis(aktualisierteErgebnisse);
            }
            
            
            
        }
        if(inTutorial)
        {
            if(TutorialCount.length==6)
            {
                Saving_Play();
                Tutorial_Step7()
            }

             if(TutorialCount.length==12)
            {
                Saving_Play();
                Tutorial_Step13()
            }
        }
    }

    const SchreibungAuswerten = () => {
    setWritingStarted(false);

    const OkayTime = Date.now();
    const FinalDelay = OkayTime - FinishTime;

    let Rating = 99;
    let Tags = [];

    
    const CurrentItem = Items[usedItems.length];
    const Zielschreibung = CurrentItem.Wort.toLowerCase();
    const SchulerSchreibung_roh = geschriebenesWort;
    const SchulerSchreibung = geschriebenesWort.toLowerCase();
    const Varianten = CurrentItem.Varianten;

    let phonologischeVarianten = [""];
    let phonographischeVarianten = [""];
    let graphematischeVarianten = [""];
    let BuchstabeFehltVariante = [""];
    let BuchstabeuberflussigVariante = [""];

    if(Varianten.length > 3)
    {
        phonologischeVarianten = Varianten[0];
        phonographischeVarianten = Varianten[1];
        graphematischeVarianten = Varianten[2];
        BuchstabeFehltVariante = Varianten[3];
        BuchstabeuberflussigVariante = Varianten[4]
    }

    const AnzahlKorrekturen = Korrekturen;
    const KeyStrokeLogging = KeyLog;
    const InitialDelay = StartDelay;

    setKorrekturen(0);
    setKeyLog([]);
    setStartDelay(0);

    

    if (SchulerSchreibung === Zielschreibung) {
        Rating = 1;
    }

    if (Rating === 99) 
    {
        if(phonologischeVarianten.length>0)
        {
            for(let v1 = 0; v1 < phonologischeVarianten.length; v1++)
            {
                if(SchulerSchreibung == phonologischeVarianten[v1].toLowerCase())
                {
                    Rating = 2;
                    Tags.push("phonologisch");
                }
            }
        }
        
        if(phonographischeVarianten.length>0)
        {
            for(let v2 = 0; v2 < phonographischeVarianten.length; v2++)
            {
                if(SchulerSchreibung == phonographischeVarianten[v2].toLowerCase())
                {
                    Rating = 2;
                    Tags.push("phonographisch");
                }
            }
        }
        
        if(graphematischeVarianten.length>0)
        {
            for(let v3 = 0; v3 < graphematischeVarianten.length; v3++)
            {
                if(SchulerSchreibung == graphematischeVarianten[v3].toLowerCase())
                {
                    Rating = 2;
                    Tags.push("graphematisch");
                }
            }
        }
        
        if(BuchstabeFehltVariante && BuchstabeFehltVariante.length>0)
        {
            for(let v4 = 0; v4 < BuchstabeFehltVariante.length; v4++)
            {
                if(SchulerSchreibung == BuchstabeFehltVariante[v4].toLowerCase())
                {
                    Rating = 2;
                    Tags.push("Buchstabe_fehlt");
                }
            }
        }
        
        if(BuchstabeuberflussigVariante && BuchstabeuberflussigVariante.length>0)
        {
            for(let v5 = 0; v5 < BuchstabeuberflussigVariante.length; v5++)
            {
                if(SchulerSchreibung == BuchstabeuberflussigVariante[v5].toLowerCase())
                {
                    Rating = 2;
                    Tags.push("Buchstabe_zu_viel");
                }
            }
        }
        
    }

    if (Rating === 99) 
    {
        Rating=3
    }

    if (usedItems.length < 6 && (Rating === 1 || Rating === 2)) {
    setManagedReferenzItems(stand => stand + 1);
    }

    const ItemErgebnis = {
        ItemId: CurrentItem.ItemId,
        Wort: CurrentItem.Wort,
        Schulerschreibung: SchulerSchreibung_roh,
        Rating: Rating,
        Tags: Tags,
        Korrekturen: AnzahlKorrekturen,
        Log: KeyStrokeLogging,
        AnfangsDelay: InitialDelay,
        Schreibzeit: WritingTime,
        SchlussDelay: FinalDelay
    };

    
    const aktualisierteErgebnisse = [...usedItems, ItemErgebnis];
    setUsedItems(aktualisierteErgebnisse);
    return aktualisierteErgebnisse;
};

   const handleGlobalStart = async () => {
    if (!soundTestPassed) {
        console.warn(
            "Die Diagnostik kann erst nach erfolgreichem Tontest starten."
        );

        return;
    }

    if (
        !audioReady ||
        !imagesReady ||
        !sequence1BlobRef.current
    ) {
        console.log(
            "Bilder und Audiodateien werden noch geladen."
        );

        return;
    }

    if(!SchulerCode && !DemoModus)
    {
        console.log("Kein Schülercode");
        return;
    }

    // Diese Aufrufe müssen unmittelbar innerhalb des Klick-Handlers erfolgen.
    const audioUnlockPromise = unlockAudio();

    // Vollbild ebenfalls noch während des Nutzer-Klicks anfordern
    setFullScreen();

    const audioUnlocked = await audioUnlockPromise;

    if (!audioUnlocked) {
        console.error("Der Ton wurde vom iPad noch nicht freigegeben.");
        return;
    }

    const zufallsTicket = Math.floor(Math.random() * 1000000);
    setTestTicket(zufallsTicket);
    setShowVersion(false);

    loadItems();
    setShowSchild(false);
    setHohlenEingang(true);
    setLogInMask(false);
    setHohleEnabled(false);

    setTimeout(() => {
        setSequence1Running(false);

        if (sequence1ObjectUrlRef.current) {
            URL.revokeObjectURL(sequence1ObjectUrlRef.current);
        }

        const freshUrl = URL.createObjectURL(
            sequence1BlobRef.current
        );

        sequence1ObjectUrlRef.current = freshUrl;
        setSequence1Src(freshUrl);

        requestAnimationFrame(() => {
            setSequence1Running(true);

           requestAnimationFrame(async () => {
                const tutorialSound = sounds.Tutorial1_1;

                const audioReady = await ensureAudioContext();

                if (!audioReady) {
                    console.error(
                        "Tutorial1_1: AudioContext ist nicht aktiv."
                    );

                    setAudioUnlockFailed(true);
                    return;
                }

    tutorialSound.stop();
    const soundId = tutorialSound.play();

                tutorialSound.once(
                    "playerror",
                    (id, error) => {
                        console.error(
                            "Tutorial1_1 konnte nicht abgespielt werden:",
                            error,
                            "AudioContext:",
                            Howler.ctx?.state
                        );
                    },
                    soundId
                );

                tutorialSound.once(
                    "end",
                    () => {
                        setSequence1Running(false);
                        setTutor("Nussweis_neutral");
                        setHohleEnabled(true);
                    },
                    soundId
                );
            });
        });
    }, 500);
};


   const startSequence3 = () => {
    if (!sequence3BlobRef.current) {
        console.error("Sequence 3 wurde noch nicht geladen.");
        return;
    }

    setSequence2Running(false);
    setSequence3Running(false);
    setTutor("Nussweis_gone");

    sequence3AudioStartedRef.current = false;

    if (sequence3ObjectUrlRef.current) {
        URL.revokeObjectURL(
            sequence3ObjectUrlRef.current
        );
    }

    const freshUrl = URL.createObjectURL(
        sequence3BlobRef.current
    );

    sequence3ObjectUrlRef.current = freshUrl;
    setSequence3Src(freshUrl);

    requestAnimationFrame(() => {
        setSequence3Running(true);
    });
};

const startSequence4 = () => {if (!sequence4BlobRef.current) {console.error("Sequence 4 wurde noch nicht geladen."); return;}

    setSequence1Running(false); setSequence2Running(false); setSequence3Running(false); setSequence4Running(false); setTutor("Nussweis_gone");
    sequence4AudioStartedRef.current = false;
    if (sequence4ObjectUrlRef.current) {URL.revokeObjectURL(sequence4ObjectUrlRef.current);}
    const freshUrl = URL.createObjectURL(sequence4BlobRef.current);
    sequence4ObjectUrlRef.current = freshUrl; setSequence4Src(freshUrl);
    requestAnimationFrame(() => {setSequence4Running(true);});
};

const startSequence5 = () => {
    setSequence4Running(false); setSequence5Running(false);  setTutor("Nussweis_gone");
    sequence5AudioStartedRef.current = false;
    if (sequence5ObjectUrlRef.current) {URL.revokeObjectURL(sequence5ObjectUrlRef.current);}
    const freshUrl = URL.createObjectURL(sequence5BlobRef.current);
    sequence5ObjectUrlRef.current = freshUrl; setSequence5Src(freshUrl);
    requestAnimationFrame(() => {setSequence5Running(true);});
};

const startSequence6 = () => {
    setSequence5Running(false); setSequence6Running(false);  setTutor("Nussweis_gone");
    sequence6AudioStartedRef.current = false;
    if (sequence6ObjectUrlRef.current) {URL.revokeObjectURL(sequence6ObjectUrlRef.current);}
    const freshUrl = URL.createObjectURL(sequence6BlobRef.current);
    sequence6ObjectUrlRef.current = freshUrl; setSequence6Src(freshUrl);
    requestAnimationFrame(() => {setSequence6Running(true);});
};

const startSequence7 = () => {
    setSequence6Running(false); setSequence7Running(false);  setTutor("Nussweis_gone");
    sequence7AudioStartedRef.current = false;
    if (sequence7ObjectUrlRef.current) {URL.revokeObjectURL(sequence7ObjectUrlRef.current);}
    const freshUrl = URL.createObjectURL(sequence7BlobRef.current);
    sequence7ObjectUrlRef.current = freshUrl; setSequence7Src(freshUrl);
    requestAnimationFrame(() => {setSequence7Running(true);});
};

const startSequence8 = () => {
    setSequence7Running(false); setSequence8Running(false);  setTutor("Nussweis_gone");
    sequence8AudioStartedRef.current = false;
    if (sequence8ObjectUrlRef.current) {URL.revokeObjectURL(sequence8ObjectUrlRef.current);}
    const freshUrl = URL.createObjectURL(sequence8BlobRef.current);
    sequence8ObjectUrlRef.current = freshUrl; setSequence8Src(freshUrl);
    requestAnimationFrame(() => {setSequence8Running(true);});
};

const startSequence9 = () => {
    setSequence8Running(false); setSequence9Running(false);  setTutor("Nussweis_gone");
    sequence9AudioStartedRef.current = false;
    if (sequence9ObjectUrlRef.current) {URL.revokeObjectURL(sequence9ObjectUrlRef.current);}
    const freshUrl = URL.createObjectURL(sequence9BlobRef.current);
    sequence9ObjectUrlRef.current = freshUrl; setSequence9Src(freshUrl);
    requestAnimationFrame(() => {setSequence9Running(true);});
};

const startSequence10 = () => {
    setSequence9Running(false); setSequence10Running(false);  setTutor("Nussweis_gone");
    sequence10AudioStartedRef.current = false;
    if (sequence10ObjectUrlRef.current) {URL.revokeObjectURL(sequence10ObjectUrlRef.current);}
    const freshUrl = URL.createObjectURL(sequence10BlobRef.current);
    sequence10ObjectUrlRef.current = freshUrl; setSequence10Src(freshUrl);
    requestAnimationFrame(() => {setSequence10Running(true);});
};

const startSequence11 = () => {
    setSequence10Running(false); setSequence11Running(false);  setTutor("Nussweis_gone");
    sequence11AudioStartedRef.current = false;
    if (sequence11ObjectUrlRef.current) {URL.revokeObjectURL(sequence11ObjectUrlRef.current);}
    const freshUrl = URL.createObjectURL(sequence11BlobRef.current);
    sequence11ObjectUrlRef.current = freshUrl; setSequence11Src(freshUrl);
    requestAnimationFrame(() => {setSequence11Running(true);});
};

const startSequence12 = () => {
    setSequence11Running(false); setSequence12Running(false);  setTutor("Nussweis_gone");
    sequence12AudioStartedRef.current = false;
    if (sequence12ObjectUrlRef.current) {URL.revokeObjectURL(sequence12ObjectUrlRef.current);}
    const freshUrl = URL.createObjectURL(sequence12BlobRef.current);
    sequence12ObjectUrlRef.current = freshUrl; setSequence12Src(freshUrl);
    requestAnimationFrame(() => {setSequence12Running(true);});
};

const startSequence13 = () => {
    setSequence12Running(false); setSequence13Running(false);  setTutor("Nussweis_gone");
    sequence13AudioStartedRef.current = false;
    if (sequence13ObjectUrlRef.current) {URL.revokeObjectURL(sequence13ObjectUrlRef.current);}
    const freshUrl = URL.createObjectURL(sequence13BlobRef.current);
    sequence13ObjectUrlRef.current = freshUrl; setSequence13Src(freshUrl);
    requestAnimationFrame(() => {setSequence13Running(true);});
};

const startSequence14 = () => {
    setSequence13Running(false); setSequence14Running(false);  setTutor("Nussweis_gone");
    sequence14AudioStartedRef.current = false;
    if (sequence14ObjectUrlRef.current) {URL.revokeObjectURL(sequence14ObjectUrlRef.current);}
    const freshUrl = URL.createObjectURL(sequence14BlobRef.current);
    sequence14ObjectUrlRef.current = freshUrl; setSequence14Src(freshUrl);
    requestAnimationFrame(() => {setSequence14Running(true);});
};

const startSequence15 = () => {
    setSequence14Running(false); setSequence15Running(false);  setTutor("Nussweis_gone");
    sequence15AudioStartedRef.current = false;
    if (sequence15ObjectUrlRef.current) {URL.revokeObjectURL(sequence15ObjectUrlRef.current);}
    const freshUrl = URL.createObjectURL(sequence15BlobRef.current);
    sequence15ObjectUrlRef.current = freshUrl; setSequence15Src(freshUrl);
    requestAnimationFrame(() => {setSequence15Running(true);});
};

const startEnde1 = () => {
    setSequence15Running(false); setSequenceEnde1Running(false);  setTutor("Nussweis_gone");
    sequenceEnde1AudioStartedRef.current = false;
    if (sequenceEnde1ObjectUrlRef.current) {URL.revokeObjectURL(sequenceEnde1ObjectUrlRef.current);}
    const freshUrl = URL.createObjectURL(sequenceEnde1BlobRef.current);
    sequenceEnde1ObjectUrlRef.current = freshUrl; setSequenceEnde1Src(freshUrl);
    requestAnimationFrame(() => {setSequenceEnde1Running(true);});
};

const startEnde2 = () => {
    if (!sequenceEnde2BlobRef.current) {
        console.error("Ende 2 wurde noch nicht geladen.");
        return;
    }

    // Keine Audioüberschneidung zulassen
    sounds.Ende_Teil1?.stop();

    setSequenceEnde1Running(false);
    setSequenceEnde2Running(false);
    setTutor("Nussweis_gone");

    sequenceEnde2AudioStartedRef.current = false;

    if (sequenceEnde2ObjectUrlRef.current) {
        URL.revokeObjectURL(
            sequenceEnde2ObjectUrlRef.current
        );
    }

    const freshUrl = URL.createObjectURL(
        sequenceEnde2BlobRef.current
    );

    sequenceEnde2ObjectUrlRef.current = freshUrl;
    setSequenceEnde2Src(freshUrl);

    requestAnimationFrame(() => {
        setSequenceEnde2Running(true);
    });
};

const handleSequence3Loaded = async () => {
    if (sequence3AudioStartedRef.current) return;

    const audioReady = await ensureAudioContext();

    if (!audioReady) {console.error( "Tutorial1_3: AudioContext ist nicht aktiv.");
        sequence3AudioStartedRef.current = false;
        return;
    }

    sequence3AudioStartedRef.current = true;
    const tutorialSound = sounds.Tutorial1_3;
    tutorialSound.stop();
    const soundId = tutorialSound.play();

    tutorialSound.once("end",() => {setSequence3Running(false);setTutor("Nussweis_gone");},soundId);
};

const handleSequence4Loaded = () => {if (sequence4AudioStartedRef.current) return; sequence4AudioStartedRef.current = true;
    const tutorialSound = sounds.Tutorial1_4;
    tutorialSound.stop();
    const soundId = tutorialSound.play();
    tutorialSound.once("end",() => {setSequence4Running(false); setTutor("Nussweis_gone");},soundId);
};

const handleSequence5Loaded = () => {if (sequence5AudioStartedRef.current) return; sequence5AudioStartedRef.current = true;
    const tutorialSound = sounds.Tutorial1_5;
    tutorialSound.stop();
    const soundId = tutorialSound.play();
    tutorialSound.once("end",() => {setSequence5Running(false); setTutor("Nussweis_gone");},soundId);
};

const handleSequence6Loaded = () => {if (sequence6AudioStartedRef.current) return; sequence6AudioStartedRef.current = true;
    const tutorialSound = sounds.Tutorial1_6;
    tutorialSound.stop();
    const soundId = tutorialSound.play();
    tutorialSound.once("end",() => {setSequence6Running(false); setTutor("Nussweis_gone");},soundId);
};

const handleSequence7Loaded = () => {if (sequence7AudioStartedRef.current) return; sequence7AudioStartedRef.current = true;
    const tutorialSound = sounds.Tutorial1_7;
    tutorialSound.stop();
    const soundId = tutorialSound.play();
    tutorialSound.once("end",() => {setSequence7Running(false); setTutor("Nussweis_gone");},soundId);
};

const handleSequence8Loaded = () => {if (sequence8AudioStartedRef.current) return; sequence8AudioStartedRef.current = true;
    const tutorialSound = sounds.Tutorial1_8;
    tutorialSound.stop();
    const soundId = tutorialSound.play();
    tutorialSound.once("end",() => {setSequence8Running(false); setTutor("Nussweis_gone");},soundId);
};

const handleSequence9Loaded = () => {if (sequence9AudioStartedRef.current) return; sequence9AudioStartedRef.current = true;
    const tutorialSound = sounds.Tutorial1_9;
    tutorialSound.stop();
    const soundId = tutorialSound.play();
    tutorialSound.once("end",() => {setSequence9Running(false); setTutor("Nussweis_gone");},soundId);
};

const handleSequence10Loaded = () => {if (sequence10AudioStartedRef.current) return; sequence10AudioStartedRef.current = true;
    const tutorialSound = sounds.Tutorial1_10;
    tutorialSound.stop();
    const soundId = tutorialSound.play();
    tutorialSound.once("end",() => {setSequence10Running(false); setTutor("Nussweis_gone");},soundId);
};

const handleSequence11Loaded = () => {if (sequence11AudioStartedRef.current) return; sequence11AudioStartedRef.current = true;
    const tutorialSound = sounds.Tutorial1_11;
    tutorialSound.stop();
    const soundId = tutorialSound.play();
    tutorialSound.once("end",() => {setSequence11Running(false); setTutor("Nussweis_gone");},soundId);
};

const handleSequence12Loaded = () => {if (sequence12AudioStartedRef.current) return; sequence12AudioStartedRef.current = true;
    const tutorialSound = sounds.Tutorial1_12;
    tutorialSound.stop();
    const soundId = tutorialSound.play();
    tutorialSound.once("end",() => {setSequence12Running(false); setTutor("Nussweis_gone");},soundId);
};

const handleSequence13Loaded = () => {if (sequence13AudioStartedRef.current) return; sequence13AudioStartedRef.current = true;
    const tutorialSound = sounds.Tutorial1_13;
    tutorialSound.stop();
    const soundId = tutorialSound.play();
    tutorialSound.once("end",() => {setSequence13Running(false); setTutor("Nussweis_gone");},soundId);
};

const handleSequence14Loaded = () => {if (sequence14AudioStartedRef.current) return; sequence14AudioStartedRef.current = true;
    const tutorialSound = sounds.Tutorial1_14;
    tutorialSound.stop();
    const soundId = tutorialSound.play();
    tutorialSound.once("end",() => {setSequence14Running(false); setTutor("Nussweis_gone");},soundId);
};

const handleSequence15Loaded = () => {if (sequence15AudioStartedRef.current) return; sequence15AudioStartedRef.current = true;
    const tutorialSound = sounds.Tutorial1_15;
    tutorialSound.stop();
    const soundId = tutorialSound.play();
    tutorialSound.once("end",() => {setSequence15Running(false); setTutor("Nussweis_gone");},soundId);
};

const handleSequenceEnde1Loaded = () => {
    if (sequenceEnde1AudioStartedRef.current) return; sequenceEnde1AudioStartedRef.current = true;

    const tutorialSound = sounds.Ende_Teil1; tutorialSound.stop(); const soundId = tutorialSound.play();

    tutorialSound.once(
        "end",
        () => {
            setSequenceEnde1Running(false);

            setIntro(true);
            setShowDiagnostikOverlay(false);
            setInside(false);

            // Kleine Pause zwischen beiden Teilen
            setTimeout(() => {
                startEnde2();
            }, 200);
        },
        soundId
    );
};

const handleSequenceEnde2Loaded = async () => {
    if (sequenceEnde2AudioStartedRef.current) return;

    sequenceEnde2AudioStartedRef.current = true;

    try {
        if (
            Howler.ctx &&
            Howler.ctx.state === "suspended"
        ) {
            await Howler.ctx.resume();
        }

        const tutorialSound = sounds.Ende_Teil2;

        if (!tutorialSound) {
            console.error(
                "Audio Ende_Teil2 existiert nicht in sounds."
            );
            sequenceEnde2AudioStartedRef.current = false;
            return;
        }

        tutorialSound.stop();

        tutorialSound.once(
            "playerror",
            (soundId, error) => {
                console.error(
                    "Ende_Teil2 konnte nicht abgespielt werden:",
                    error
                );

                sequenceEnde2AudioStartedRef.current = false;
            }
        );

        tutorialSound.once(
            "loaderror",
            (soundId, error) => {
                console.error(
                    "Ende_Teil2 konnte nicht geladen werden:",
                    error
                );

                sequenceEnde2AudioStartedRef.current = false;
            }
        );

        const soundId = tutorialSound.play();

        console.log(
            "Ende_Teil2 gestartet.",
            {
                soundId,
                audioContext: Howler.ctx?.state,
                loadedState: tutorialSound.state()
            }
        );

        tutorialSound.once(
            "end",
            () => {
                setSequenceEnde2Running(false);
                setTutor("Nussweis_gone");
            },
            soundId
        );
    } catch (error) {
        sequenceEnde2AudioStartedRef.current = false;

        console.error(
            "Fehler beim Start von Ende_Teil2:",
            error
        );
    }
};

    const EnterHohle = () => {
    if (!HohleClicked && HohleEnabled) {
        setHohleClicked(true);
        setHohleEnabled(false);
        setKeyboardAktiv(false);

        // Neutrales GIF zunächst entfernen
        setTutor("Nussweis_gone");
        setSequence2Running(false);

        const freshUrl = URL.createObjectURL(
            sequence2BlobRef.current
        );

        sequence2ObjectUrlRef.current = freshUrl;
        setSequence2Src(freshUrl);

        requestAnimationFrame(() => {
            // Sequence 2 wird neu eingesetzt und beginnt bei Frame 1
            setSequence2Running(true);

            requestAnimationFrame(async () => {
                    const tutorialSound = sounds.Tutorial1_2;

                    const audioReady = await ensureAudioContext();

                    if (!audioReady) {
                        console.error(
                            "Tutorial1_2: AudioContext ist nicht aktiv."
                        );

                        setAudioUnlockFailed(true);
                        return;
                    }

                    tutorialSound.stop();
                    const soundId = tutorialSound.play();

                tutorialSound.once(
                    "end",
                    () => {
                        setSequence2Running(false);
                        setTutor("Nussweis_gone");
                    },
                    soundId
                );
            });
        });

        setTimeout(() => {
            startSequence3();
        }, 5000);

        setGlow(true);

        setTimeout(() => {
            setIntro(false);
        }, 1000);

        setTimeout(() => {
            setGlow(false);
            setFadeout(true);
        }, 2000);

        setTimeout(() => {
            setFadeout(false);
            setInside(true);
        }, 4500);

        setTimeout(() => {
            setShowDiagnostikOverlay(true);
        }, 33000);

        setTimeout(() => {
            MagicLoadItem();
        }, 40000);

        setTimeout(() => {
            setShowTutItem1(true);
        }, 42000);

        setTimeout(() => {
            Tutorial_Step1();
        }, 69000);
    }
};

    const Tutorial_Step1 = () =>{
        setIdle2Enabled(true);
        setKeyGroßschreiben('Key3_glow');
        setTimeout(()=>{setKeyboardAktiv(true)},500)
        TutorialCount.push(1);
    }

    const Tutorial_Step2 = () =>{
        startSequence4(); 
        setKeyboardAktiv(false);
        setKeyGroßschreiben('Key3');
        setTimeout(()=>{setKeyE('Key1_glow'); setKeyboardAktiv(true)},2800);
        TutorialCount.push(1);
    }

    const Tutorial_Step3 = () =>{
        setKeyboardAktiv(false);
        startSequence5();
        setKeyE('Key1'); setKeyGroßschreiben("Key3");
        setTimeout(()=>{setKeyN('Key1_glow'); setKeyboardAktiv(true)},7000);
        TutorialCount.push(1);
        //console.log("Tutorial-Counter: "+TutorialCount.length);
    }

    const Tutorial_Step4 = () =>{
        setKeyboardAktiv(false);
        startSequence6()
        setKeyN('Key1');setKeyE('Key1');
        setTimeout(()=>{setKeyT('Key1_glow'); setKeyboardAktiv(true)},6000);
        TutorialCount.push(1);
        //console.log("Tutorial-Counter: "+TutorialCount.length);
    }

    const Tutorial_Step5 = () =>{
        setKeyboardAktiv(false);
        startSequence7();
        setKeyT('Key1');setKeyN('Key1');setKeyE('Key1');setKeyGroßschreiben("Key3");
        setTimeout(()=>{setKeyE('Key1_glow'); setKeyboardAktiv(true)},9500);
        TutorialCount.push(1);
        //console.log("Tutorial-Counter: "+TutorialCount.length);
    }

    const Tutorial_Step6 = () =>{
        setKeyboardAktiv(false);
        startSequence8();
        setKeyE('Key1');setKeyT('Key1');setKeyN('Key1');setKeyGroßschreiben("Key3");
        setTimeout(()=>{setNussButton('NussButton_glow'); setKeyboardAktiv(true)},10000);
        TutorialCount.push(1);
        //console.log("Tutorial-Counter: "+TutorialCount.length);
    }


    const Tutorial_Step7 = () =>{
        setKeyboardAktiv(false);
        startSequence9();
        setNussButton('NussButton');
        setGeschriebenesWort("...")
        setShowItem(false);
        setShowTutItem1(false);
        setMagicLoading(true);
        TutorialCount.push(1);
        console.log("Tutorial-Counter: "+TutorialCount.length);
        setTimeout(()=>{setGeschriebenesWort("...laden...")}, 2000)
        setTimeout(()=>{setGeschriebenesWort("...")}, 2500)
        setTimeout(()=>{setGeschriebenesWort("...laden...")}, 3000)
        setTimeout(()=>{setGeschriebenesWort("...")}, 3500)
        setTimeout(()=>{setGeschriebenesWort("...laden...")}, 4000)
        setTimeout(()=>{setGeschriebenesWort("...")}, 5000)
        setTimeout(()=>{setMagicLoading(false);}, 5000)
        setTimeout(()=>{setShowTutItem2(true)}, 5200)
        setTimeout(()=>{setKeyF('Key1_glow'); setKeyGroßschreiben('Key3_glow'); setGeschriebenesWort(""); setKeyboardAktiv(true)}, 27000)
    }

    const Tutorial_Step8 = () =>{
        setKeyboardAktiv(false);
        startSequence10();
        setNussButton('NussButton');
        setKeyF('Key1');setKeyT('Key1');setKeyN('Key1');setKeyE('Key1');
        setKeyGroßschreiben('Key3');
        setTimeout(()=>{setKeyU('Key1_glow'); setKeyboardAktiv(true)},4000);
        TutorialCount.push(1);
        //console.log("Tutorial-Counter: "+TutorialCount.length);
    }

    const Tutorial_Step9 = () =>{
        setKeyboardAktiv(false);
        startSequence11();
        setKeyU('Key1');setKeyF('Key1');setKeyT('Key1');setKeyN('Key1');setKeyE('Key1');setKeyGroßschreiben("Key3");
        setTimeout(()=>{setKeyß('Key1_glow'); setKeyboardAktiv(true)},5000);
        TutorialCount.push(1);
        //console.log("Tutorial-Counter: "+TutorialCount.length);
    }

    const Tutorial_Step10 = () =>{
        setKeyboardAktiv(false);
        startSequence12();
        setKeyß('Key1');setKeyF('Key1');setKeyT('Key1');setKeyN('Key1');setKeyE('Key1');setKeyGroßschreiben("Key3");
        setTimeout(()=>{setKeyBackspace('Key2_glow'); setKeyboardAktiv(true)},16000);
        TutorialCount.push(1);
        //console.log("Tutorial-Counter: "+TutorialCount.length);
    }

    const Tutorial_Step11 = () =>{
        setKeyboardAktiv(false);
        startSequence13();
        setKeyBackspace('Key2'); setKeyF('Key1');setKeyT('Key1'); setKeyU('Key1'); setKeyß('Key1');setKeyN('Key1');setKeyE('Key1');setKeyGroßschreiben("Key3");
        setTimeout(()=>{setKeyß('Key1_glow'); setKeyboardAktiv(true)},6000);
        TutorialCount.push(1);
        //console.log("Tutorial-Counter: "+TutorialCount.length);
    }

    const Tutorial_Step12 = () =>{
        setKeyboardAktiv(false);
        startSequence14();
        setKeyß('Key1');setKeyGroßschreiben("Key3"); setKeyBackspace("Key2");
        setTimeout(()=>{setNussButton('NussButton_glow'); setKeyboardAktiv(true);},4000);
        TutorialCount.push(1);
        }
     
    const Tutorial_Step13 = () =>{
        setKeyboardAktiv(false);
        startSequence15();
        setInTutorial(false);
        setOkayButton(false);
        setNussButton('NussButton');
        setTimeout(()=>{setAudioRepeatButton('AudioRepeatButton_glow');},22000);
        setTimeout(()=>{setAudioRepeatButton('AudioRepeatButton');},24000);
        TutorialCount.push(1);
        setTimeout(()=>{setShowTutItem2(false); Finish_Tutorial()}, 35000)
        }

 const Finish_Diagnosis = async (ergebnisse) => {
    setDiagnosisActive(false);
    setKeyboardAktiv(false);
    setIdle2Enabled(false);
    setShowItem(false);

    startEnde1();
    if(!DemoModus)
    {
       try {
        const saveResponse = await axios.post(
            Api + "saveRechtschreibErgebnisse",
            {
                Schulcode,
                LehrerCode,
                SchulerCode,
                SchulerKlasse,
                SchulerKlassenstufe: UseKlassenstufe,
                testTicket,
                usedItems: ergebnisse
            }
        );

        console.log(
            "Ergebnisse erfolgreich gespeichert:",
            saveResponse.data
        );

        const diagnoseResponse = await axios.post(
            Api + "doRechtschreibDiagnose",
            {
                SchulerCode,
                testTicket
            }
        );

        console.log(
            "Rechtschreibdiagnose gestartet:",
            diagnoseResponse.data
        );

        // Modal erst nach beiden erfolgreichen Requests
        setTimeout(()=> setShowSuccessModal(true), 36000)
    } catch (error) {
        console.error(
            "Fehler beim Speichern oder Diagnostizieren:",
            error.response?.data || error.message
        );
    } 
    }
    
};
    
    const Finish_Tutorial = () => {
    setInTutorial(false);
    setDiagnosisActive(true);
    setGeschriebenesWort("");

    setTimeout(() => {
        MagicLoadItem();
    }, 2000);
};

        //console.log("Tutorial-Counter: "+TutorialCount.length);
    


    const setFullScreen = async () => {
    const el = containerRef.current;

    if (!el) return;

    // Nicht erneut anfordern, wenn Vollbild bereits aktiv ist
    if (
        document.fullscreenElement ||
        document.webkitFullscreenElement
    ) {
        return;
    }

    try {
        if (el.requestFullscreen) {
            await el.requestFullscreen();
        } else if (el.webkitRequestFullscreen) {
            el.webkitRequestFullscreen();
        }
    } catch (error) {
        console.warn(
            "Vollbildmodus konnte nicht aktiviert werden:",
            error
        );
    }
};
    

   const ReplayAudio = async () => {
    if (
        !currentItem ||
        replaysRemaining <= 0 ||
        replayBusy
    ) {
        return;
    }

    // Verhindert schnelle Mehrfachklicks
    setReplayBusy(true);

    const started = await Play_Item_Sound(
        currentItem.Wort
    );

    // Nur zählen, wenn der Ton wirklich gestartet wurde
    if (started) {
        setReplaysRemaining((previous) =>
            Math.max(0, previous - 1)
        );
    }

    setReplayBusy(false);
};

    useEffect(() => {
    return () => {
        [
            sequence1ObjectUrlRef,
            sequence2ObjectUrlRef,
            sequence3ObjectUrlRef,
            sequence4ObjectUrlRef,
            sequence5ObjectUrlRef,
            sequence6ObjectUrlRef,
            sequence7ObjectUrlRef,
            sequence8ObjectUrlRef,
            sequence9ObjectUrlRef,
            sequence10ObjectUrlRef,
            sequence11ObjectUrlRef,
            sequence12ObjectUrlRef,
            sequence13ObjectUrlRef,
            sequence14ObjectUrlRef,
            sequence15ObjectUrlRef,
        ].forEach((urlRef) => {
            if (urlRef.current) {
                URL.revokeObjectURL(urlRef.current);
            }
        });
    };
}, []);

const unlockAudio = async () => {
    try {
        Howler.mute(false);
        Howler.volume(1);

        const context = Howler.ctx;

        if (!context) {
            console.error(
                "Howler-AudioContext wurde nicht erstellt."
            );

            return false;
        }

        if (context.state !== "running") {
            await context.resume();
        }
        /*
         * Sehr kurzer leerer Buffer. Dadurch wird die Audioausgabe
         * auf iOS unmittelbar beim Nutzerklick initialisiert.
         */
        const buffer = context.createBuffer(
            1,
            1,
            context.sampleRate
        );

        const source = context.createBufferSource();

        source.buffer = buffer;
        source.connect(context.destination);
        source.start(0);

        console.log("AudioContext nach Freigabe:", context.state
        );

        return context.state === "running";
    } catch (error) {
        console.error("Audio konnte nicht aktiviert werden:", error);

        return false;
    }
};

const playSoundTest = async () => {
    if (soundTestPlaying) return;

    setSoundTestPlaying(true);
    setSoundTestError(false);

    try {
        /*
         * Der Klick auf „Ton testen“ ist die notwendige
         * Nutzerinteraktion für iPadOS.
         */
        const audioUnlocked = await unlockAudio();

        if (!audioUnlocked) {
            console.error("AudioContext konnte für den Tontest nicht aktiviert werden.");

            setSoundTestError(true);
            setSoundTestPlaying(false);
            return;
        }

        const testSound = sounds?.Tontest;

        if (!testSound) {
            console.error("Der Sound „Tontest“ wurde nicht gefunden.");

            setSoundTestError(true);
            setSoundTestPlaying(false);
            return;
        }

        testSound.stop();

        testSound.once(
            "playerror",
            (soundId, error) => {
                console.error("Tontest konnte nicht abgespielt werden:", error);

                setSoundTestError(true);
                setSoundTestPlaying(false);
            }
        );

        testSound.once(
            "loaderror",
            (soundId, error) => {
                console.error("Tontest konnte nicht geladen werden:",error);

                setSoundTestError(true);
                setSoundTestPlaying(false);
            }
        );

        const soundId = testSound.play();

        testSound.once(
            "play",
            () => {console.log("Tontest läuft.",
                    {
                        soundId,
                        audioContext: Howler.ctx?.state
                    }
                );

                setSoundTestStarted(true);
            },
            soundId
        );

        testSound.once(
            "end",
            () => {
                setSoundTestPlaying(false);
            },
            soundId
        );
    } catch (error) {
        console.error("Fehler beim Tontest:", error);

        setSoundTestError(true);
        setSoundTestPlaying(false);
    }
};

const handleSoundHeard = () => {
    sounds?.Tontest?.stop();

    setSoundTestPlaying(false);
    setSoundTestError(false);
    setSoundTestPassed(true);

    console.log("Tontest wurde erfolgreich bestätigt.");
};

const handleSoundNotHeard = async () => {
    sounds?.Tontest?.stop();

    setSoundTestPlaying(false);
    setSoundTestPassed(false);
    setSoundTestError(false);

    /*
     * Erneuter Start über diesen Klick.
     * Das ist auf iPads eine neue Nutzerinteraktion.
     */
    await playSoundTest();
};

const ensureAudioContext = async () => {
    try {
        if (Howler.ctx && Howler.ctx.state !== "running") {
            console.warn("AudioContext wird fortgesetzt:",Howler.ctx.state);
            await Howler.ctx.resume();
        }

        return Howler.ctx?.state === "running";
    } catch (error) {
        console.error("AudioContext konnte nicht fortgesetzt werden:", error
        );

        return false;
    }
};

const laterSequenceRunning = sequence4Running || sequence5Running || sequence6Running || sequence7Running || sequence8Running || sequence9Running || sequence10Running ||
    sequence11Running || sequence12Running || sequence13Running || sequence14Running || sequence15Running;

    const currentItem = Items?.[usedItems.length];
    const diagnosticProgress =  UmfangItems > 0 ? Math.min(100, (usedItems.length / UmfangItems) * 100) : 0;

    if (!appReady) {
        return (
            <div className="PreloadScreen">
                <div className="PreloadCard">
                    <div className="PreloadTitle">KOMPASS</div>
                    <div className="PreloadSubtitle">Rechtschreibdiagnostik wird vorbereitet</div>

                    <div className="PreloadBar">
                        <div className="PreloadBarFill" style={{width: `${loadingProgress}%`}}/></div>
                        <div className="PreloadPercentage">{loadingProgress} %</div>

                    <div className="PreloadCount">{loadedAssetCount} von{" "} {totalAssetCount || "…"} Dateien </div>

                    <div className="PreloadLabel">{loadingError ? loadingError : loadingLabel}</div>

                    {loadingError && (
                        <button className="PreloadRetryButton" onClick={() => { window.location.reload();}}>Erneut versuchen</button>
                    )}
                </div>
            </div>
        );
    }

    return(
        <div className="Wrapper" ref={containerRef}>
            <div
                className="DiagnosticStage"
                style={{ "--stage-scale": scale }}
            >
            {diagnosisActive && UmfangItems > 0 && (<div className="DiagnosticProgress"> <div className="DiagnosticProgressText"> </div>

        <div className="DiagnosticProgressTrack" role="progressbar" aria-valuemin="0" aria-valuemax={UmfangItems} aria-valuenow={usedItems.length} >
            <div className="DiagnosticProgressFill" style={{width: `${diagnosticProgress}%`}} />
        </div>
    </div>
)}
    {LogInMask && soundTestStarted && !soundTestPassed && (
    <div className="SoundTestOverlay">
        <div className="SoundTestDialog">
            <div className="SoundTestTitle">Kannst du den Ton hören?</div>

            <div className="SoundTestOptions">
                <button type="button" className="SoundTestNo" onClick={handleSoundNotHeard}>
                    <span className="SoundTestIcon">🎧</span>
                    <span>Ich höre nichts!</span>
                </button>

                <button type="button" className="SoundTestYes" onClick={handleSoundHeard}>
                    <span className="SoundTestIcon">🎧 🎵 </span>
                    <span>Ich höre etwas!</span>
                </button>
            </div>

            {soundTestError && (
                <div className="SoundTestError">Der Ton konnte nicht gestartet werden. Tippe bitte noch einmal auf „Ich höre nichts“.</div>
            )}
        </div>
    </div>
)}
            {showDiagnosticOverlay ? <div className="DiagnostikOverlay">
                <div className="MalereienArea">
                    <div className="MalereienArea_Smallrow">
                        <div className="Empty"></div>
                        <div className="RandMalerei"></div>
                        <div className="RandMalerei"></div>
                        <div className="RandMalerei"></div>
                        <div className="Empty"></div>
                    </div>
                    <div className="MalereienArea_Bigrow">
                        <div className="BigRow_Side">
                            <div className="Randmalerei2"></div>
                            <div className="Randmalerei2"></div>
                        </div>
                        <div className="BigRow_Center">
                            {MagicLoading ?  <div className="MagicLoader"></div>: <></>}
                            {ShowItem && currentItem && (<div className={currentItem.Bildimpuls}></div>)}
                            {ShowTutItem1 ? <div className="ItemBild_Ente"></div> : <></>}
                            {ShowTutItem2 ? <div className="ItemBild_Fuß"></div> : <></>}
                        </div>
                        <div className="BigRow_Side">
                            <div className="Randmalerei2"></div>
                            <div className="Randmalerei2"></div>
                        </div>
                    </div>
                    <div className="MalereienArea_Smallrow">
                        <div className="Empty"></div>
                        <div className="RandMalerei"></div>
                        <div className="RandMalerei"></div>
                        <div className="RandMalerei"></div>
                        <div className="Empty"></div>
                    </div>
                </div>
                <div className={NussButton} onClick={handleOkayClick}></div>
                <div className={AudioRepeatButton} onClick={ReplayAudio}></div>
                <div className="Schreibzettel">{geschriebenesWort}</div>
                {MagicLoading ? <div className="Lichtstrahl"></div> : <></>}
                {Knackomat_pressed ? <div className="Knackomat_pressed"></div> : <div className="Knackomat"></div>}
                <div className="TastaturArea">
                    <div className="TastaturRow">
                        <div className="TastaturToprow">
                            <div className="Key1" onClick={() => {Majuskeln ? handleTaste("Q") : handleTaste("q")}}>{Majuskeln ? "Q" : "q"}</div>
                            <div className="Key1" onClick={() => {Majuskeln ? handleTaste("W") : handleTaste("w")}}>{Majuskeln ? "W" : "w"}</div>
                            <div className={KeyE} onClick={() => {Majuskeln ? handleTaste("E") : handleTaste("e")}}>{Majuskeln ? "E" : "e"}</div>
                            <div className="Key1" onClick={() => {Majuskeln ? handleTaste("R") : handleTaste("r")}}>{Majuskeln ? "R" : "r"}</div>
                            <div className={KeyT} onClick={() => {Majuskeln ? handleTaste("T") : handleTaste("t")}}>{Majuskeln ? "T" : "t"}</div>
                            <div className="Key1" onClick={() => {Majuskeln ? handleTaste("Z") : handleTaste("z")}}>{Majuskeln ? "Z" : "z"}</div>
                            <div className={KeyU} onClick={() => {Majuskeln ? handleTaste("U") : handleTaste("u")}}>{Majuskeln ? "U" : "u"}</div>
                            <div className="Key1" onClick={() => {Majuskeln ? handleTaste("I") : handleTaste("i")}}>{Majuskeln ? "I" : "i"}</div>
                            <div className="Key1" onClick={() => {Majuskeln ? handleTaste("O") : handleTaste("o")}}>{Majuskeln ? "O" : "o"}</div>
                            <div className="Key1" onClick={() => {Majuskeln ? handleTaste("P") : handleTaste("p")}}>{Majuskeln ? "P" : "p"}</div>
                            <div className="Key1" onClick={() => {Majuskeln ? handleTaste("Ü") : handleTaste("ü")}}>{Majuskeln ? "Ü" : "ü"}</div>
                            <div className={KeyBackspace} onClick={handleBackspace}>←</div>
                        </div>
                    </div>
                    <div className="TastaturRow">
                        <div className="TastaturMiddleRow">
                            <div className="Key1" onClick={() => {Majuskeln ? handleTaste("A") : handleTaste("a")}}>{Majuskeln ? "A" : "a"}</div>
                            <div className="Key1" onClick={() => {Majuskeln ? handleTaste("S") : handleTaste("s")}}>{Majuskeln ? "S" : "s"}</div>
                            <div className="Key1" onClick={() => {Majuskeln ? handleTaste("D") : handleTaste("d")}}>{Majuskeln ? "D" : "d"}</div>
                            <div className={KeyF} onClick={() => {Majuskeln ? handleTaste("F") : handleTaste("f")}}>{Majuskeln ? "F" : "f"}</div>
                            <div className="Key1" onClick={() => {Majuskeln ? handleTaste("G") : handleTaste("g")}}>{Majuskeln ? "G" : "g"}</div>
                            <div className="Key1" onClick={() => {Majuskeln ? handleTaste("H") : handleTaste("h")}}>{Majuskeln ? "H" : "h"}</div>
                            <div className="Key1" onClick={() => {Majuskeln ? handleTaste("J") : handleTaste("j")}}>{Majuskeln ? "J" : "j"}</div>
                            <div className="Key1" onClick={() => {Majuskeln ? handleTaste("K") : handleTaste("k")}}>{Majuskeln ? "K" : "k"}</div>
                            <div className="Key1" onClick={() => {Majuskeln ? handleTaste("L") : handleTaste("l")}}>{Majuskeln ? "L" : "l"}</div>
                            <div className="Key1" onClick={() => {Majuskeln ? handleTaste("Ö") : handleTaste("ö")}}>{Majuskeln ? "Ö" : "ö"}</div>
                            <div className="Key1" onClick={() => {Majuskeln ? handleTaste("Ä") : handleTaste("ä")}}>{Majuskeln ? "Ä" : "ä"}</div>
                            <div className="Key5" >←</div>
                        </div>
                    </div>
                    <div className="TastaturRow">
                        <div className="TastaturBottomRow">
                            <div className="Key1" onClick={() => {Majuskeln ? handleTaste("Y") : handleTaste("y")}}>{Majuskeln ? "Y" : "y"}</div>
                            <div className="Key1" onClick={() => {Majuskeln ? handleTaste("X") : handleTaste("x")}}>{Majuskeln ? "X" : "x"}</div>
                            <div className="Key1" onClick={() => {Majuskeln ? handleTaste("C") : handleTaste("c")}}>{Majuskeln ? "C" : "c"}</div>
                            <div className="Key1" onClick={() => {Majuskeln ? handleTaste("V") : handleTaste("v")}}>{Majuskeln ? "V" : "v"}</div>
                            <div className="Key1" onClick={() => {Majuskeln ? handleTaste("B") : handleTaste("b")}}>{Majuskeln ? "B" : "b"}</div>
                            <div className={KeyN} onClick={() => {Majuskeln ? handleTaste("N") : handleTaste("n")}}>{Majuskeln ? "N" : "n"}</div>
                            <div className="Key1" onClick={() => {Majuskeln ? handleTaste("M") : handleTaste("m")}}>{Majuskeln ? "M" : "m"}</div>
                            <div className={Keyß} onClick={() => {Majuskeln ? handleTaste("ẞ") : handleTaste("ß")}}>{Majuskeln ? "ẞ" : "ß"}</div>
                            <div className="Key6">M</div>
                            <div className={KeyGroßschreiben} onClick={Großschreiben}>↥Aa </div> 
                            <div className="Key6">M</div>                           
                        </div>
                    </div>
                </div>
            </div> : <></>}
        {Intro ? <div className="Background1"></div> : <></>}
        {Glow ? <div className="Background1_2"></div> : <></>}
        {FadeOut ? <div className="Background1_3"></div> : <></>}
        {Inside ? <div className="Background2"></div> : <></>}
        {HohlenEingang ? <div className="HohlenEingangButton" onClick={EnterHohle}></div> : <></>}
        {showSchild ? <div className="LoginSchild"></div> : <></>}
        {LogInMask ? (
        <div className="LogInField">
        <div className="LoginField_Header">Willkommen!</div>
        <div className="LoginField_Label"><b>Lernendencode: </b>{SchulerCode}</div>
        <div className="LoginField_Label"><b>Klasse: </b>{SchulerKlasse}</div>
        <div className="LoginField_Label"><b>Klassenstufe: </b>{UseKlassenstufe}</div>

        <div className="LoginActionArea">
    {!soundTestPassed ? (
        <button type="button" className="SoundTestStartButton" onClick={playSoundTest}disabled={soundTestPlaying}>
            <span className="SoundTestSpeaker">🔊</span>
            <span>{soundTestPlaying ? "Testton läuft …" : soundTestStarted ? "Ton erneut testen" : "Ton testen"}</span>
        </button>
    ) : (
        <button type="button" className="GlobalStartButton" onClick={handleGlobalStart} aria-label="Diagnostik starten">
            <span>Start</span>
            <span className="StartArrow">→</span>
        </button>
    )}
</div>
    </div>
) : null}
       {sequence1Running && (<img key={sequence1Src} src={sequence1Src} className="Nussweis_Sequence1" alt=""draggable={false}/>)}
       {sequence2Running && (<img key={sequence2Src} src={sequence2Src} className="Nussweis_Sequence2" alt="" draggable={false}/>)}
       {sequence3Running && (<img key={sequence3Src} src={sequence3Src} className="Nussweis_Sequence3" alt="" draggable={false} onLoad={handleSequence3Loaded}
        onError={() => {console.error("Safari konnte Sequence 3 nicht dekodieren.",{src: sequence3Src, type: sequence3BlobRef.current?.type, size: sequence3BlobRef.current?.size});}}/>)}
       {sequence4Running && (<img key={sequence4Src} src={sequence4Src} className="Nussweis_Sequence4" alt="" draggable={false} onLoad={handleSequence4Loaded}/>)}
       {sequence5Running && (<img key={sequence5Src} src={sequence5Src} className="Nussweis_Sequence4" alt="" draggable={false} onLoad={handleSequence5Loaded}/>)}
       {sequence6Running && (<img key={sequence6Src} src={sequence6Src} className="Nussweis_Sequence4" alt="" draggable={false} onLoad={handleSequence6Loaded}/>)}
       {sequence7Running && (<img key={sequence7Src} src={sequence7Src} className="Nussweis_Sequence4" alt="" draggable={false} onLoad={handleSequence7Loaded}/>)}
       {sequence8Running && (<img key={sequence8Src} src={sequence8Src} className="Nussweis_Sequence4" alt="" draggable={false} onLoad={handleSequence8Loaded}/>)}
       {sequence9Running && (<img key={sequence9Src} src={sequence9Src} className="Nussweis_Sequence4" alt="" draggable={false} onLoad={handleSequence9Loaded}/>)}
       {sequence10Running && (<img key={sequence10Src} src={sequence10Src} className="Nussweis_Sequence4" alt="" draggable={false} onLoad={handleSequence10Loaded}/>)}
       {sequence11Running && (<img key={sequence11Src} src={sequence11Src} className="Nussweis_Sequence4" alt="" draggable={false} onLoad={handleSequence11Loaded}/>)}
       {sequence12Running && (<img key={sequence12Src} src={sequence12Src} className="Nussweis_Sequence4" alt="" draggable={false} onLoad={handleSequence12Loaded}/>)}
       {sequence13Running && (<img key={sequence13Src} src={sequence13Src} className="Nussweis_Sequence4" alt="" draggable={false} onLoad={handleSequence13Loaded}/>)}
       {sequence14Running && (<img key={sequence14Src} src={sequence14Src} className="Nussweis_Sequence4" alt="" draggable={false} onLoad={handleSequence14Loaded}/>)}
       {sequence15Running && (<img key={sequence15Src} src={sequence15Src} className="Nussweis_Sequence4" alt="" draggable={false} onLoad={handleSequence15Loaded}/>)}
       {sequenceEnde1Running && (<img key={sequenceEnde1Src} src={sequenceEnde1Src} className="Nussweis_Sequence4" alt="" draggable={false} onLoad={handleSequenceEnde1Loaded}/>)}
       {sequenceEnde2Running && (<img key={sequenceEnde2Src} src={sequenceEnde2Src} className="Nussweis_Sequence1" alt="" draggable={false} onLoad={handleSequenceEnde2Loaded}/>)}

       {!sequence1Running && !sequence2Running && Tutor === "Nussweis_neutral" && (
        <img src={NussweisIdle} className="Nussweis_neutral" alt="" draggable={false}/>)}

        {idle2Enabled && !laterSequenceRunning && (<img src={NussweisIdle2} className="Nussweis_Sequence4" alt="" draggable={false}/>)}

{!sequence1Running && !sequence2Running && Tutor !== "Nussweis_neutral" && (<div className={Tutor}></div>)}
        </div>    
        {audioUnlockFailed && (
    <div className="AudioUnlockOverlay">
        <p>Der Ton muss noch aktiviert werden.</p>

        <button onClick={async () => {setAudioUnlockFailed(false);
                const audioUnlocked = await unlockAudio();

                if (!audioUnlocked) {setAudioUnlockFailed(true);}
            }}
        >Ton aktivieren</button>
    </div>
)}
    {showVersion ? <div className="VersionsLabel">Version: {version}</div> :<></>}
    {showSuccessModal && (<div className="DiagnosisSuccessOverlay" role="dialog" aria-modal="true" aria-labelledby="diagnosis-success-title">
        <div className="DiagnosisSuccessModal">
            <div className="DiagnosisSuccessIcon">✓</div>
            <h2 id="diagnosis-success-title">Fertig!</h2>

            <p>Deine Ergebnisse wurden erfolgreich gespeichert.</p>

            <button type="button" className="DiagnosisSuccessButton" onClick={() => setShowSuccessModal(false)}>Okay</button>
        </div>
    </div>
)}
        </div>
    )

}
export default Rechtschreiben;
